import React from 'react';
import trustpilotLogoDark from './assets/TrustpilotLogoDark.svg';
import { TRUSTPILOT_REVIEWS, TRUSTPILOT_REVIEW_DATA } from './constants';
import TestimonialsCarousel from './TestimonialsCarousel';
import TrustpilotSectionTitle from './TrustpilotSectionTitle';
import {
  Container,
  RatingLine,
  Section,
  Subtitle,
  TitleSection,
  TrustpilotFooter,
  TrustpilotLine,
  TrustpilotLink,
  TrustpilotLogo,
  WrapperSection,
} from './styles';
import { TrustpilotSectionProps } from './types';

const TrustpilotFooterBar: React.FC = () => (
  <TrustpilotFooter>
    <RatingLine>
      Rated <strong>{TRUSTPILOT_REVIEW_DATA.score}</strong> / 5 based on{' '}
      <TrustpilotLink
        href="https://www.trustpilot.com/review/policygenius.com"
        target="_blank"
        rel="noreferrer"
      >
        {TRUSTPILOT_REVIEW_DATA.numberOfReviews} reviews
      </TrustpilotLink>
      .
    </RatingLine>
    <TrustpilotLine>
      See all reviews at{' '}
      <TrustpilotLogo
        src={trustpilotLogoDark}
        alt="Trustpilot"
        loading="lazy"
        width={145}
        height={34}
      />
    </TrustpilotLine>
  </TrustpilotFooter>
);

const TrustpilotSection: React.FC<TrustpilotSectionProps> = ({ inheritBackground }) => {
  const useCarousel = TRUSTPILOT_REVIEWS.length > 4;

  return (
    <Section aria-labelledby="referral-trustpilot-title">
      <WrapperSection $inheritBackground={inheritBackground}>
        <Container>
          <TitleSection>
            <TrustpilotSectionTitle />
            <Subtitle>
              Policygenius provides free quotes tailored to your needs with support from licensed
              agents, helping you get insurance coverage fast so you can get on with life.
            </Subtitle>
          </TitleSection>

          {useCarousel && <TestimonialsCarousel items={TRUSTPILOT_REVIEWS} />}

          <TrustpilotFooterBar />
        </Container>
      </WrapperSection>
    </Section>
  );
};

export default TrustpilotSection;
